/**
 * Remove rest button added manually on webform-submission.
 */
const $ = window.jQuery;

export default {
  attach: function(context, settings) {
    let $newContent = $(context);
    let $webform = $newContent.find('form.webform-submission-form');
    let $webformPreview = $webform.find('.webform-preview');

    if ($webformPreview.length > 0) {
      let $resetButton = $webform.find('.form-actions .reset-form');

      if ($resetButton.length > 0) {
        $resetButton.remove();
      };
    };
  },
}
